import cx from 'classnames';
import React, { PropTypes } from 'react';

import { ATTENDANCE } from 'entities/Activity';
import ActivityRecipient from 'entities/ActivityRecipient';
import Button from 'components/Button.jsx';
import EventTracking from 'lib/EventTracking';
import trackView from 'lib/trackView';
import FocusEventTrigger from 'components/FocusEventTrigger.jsx';
import Form from 'components/Form.jsx';
import FormCheckBox from 'components/FormCheckBox.jsx';
import FormInput from 'components/FormInput.jsx';
import isEmail from 'lib/isEmail';
import isPhone from 'lib/isPhone';
import Link from 'components/Link.jsx';
import LinkConstants from 'constants/LinkConstants';
import withWidth from 'lib/withWidth';
import Textarea from 'components/Textarea.jsx';

import EventRSVPForm from './EventRSVPForm.jsx';
import styles from './styles/EventParticipationForm.css';

const DEFAULT_INITIAL_RESPONSE = ATTENDANCE.YES;
const UI_CONTEXT = null;

export const EventParticipationForm = React.createClass({
  propTypes: {
    initialRSVP: PropTypes.oneOf([ATTENDANCE.YES, ATTENDANCE.NO, ATTENDANCE.MAYBE]),
    eventScreenName: PropTypes.string,
    onValidSubmit: PropTypes.func.isRequired,
    showParticipantIdentityFields: PropTypes.bool,
    editableEventRecipient: PropTypes.instanceOf(ActivityRecipient),
    processingSubmit: PropTypes.bool,
    isCollectingMoney: PropTypes.bool,
    width: PropTypes.number.isRequired,
  },

  contextTypes: {
    isPreview: PropTypes.bool,
  },

  getDefaultProps() {
    return {
      showParticipantIdentityFields: true,
      processingSubmit: false,
      isCollectingMoney: false,
    };
  },

  getInitialState() {
    let response = DEFAULT_INITIAL_RESPONSE;

    if (this.props.initialRSVP) {
      response = this.props.initialRSVP;
    } else if (this.props.editableEventRecipient) {
      response = this.props.editableEventRecipient.getAttendance();
    }

    return {
      response,
      contribute: false,
      disabled: true,
    };
  },

  onResponseChange(response) {
    this.setState({ response });
  },

  onValidSubmit(values, reset, errors) {
    const {
      eventScreenName,
      onValidSubmit,
      showParticipantIdentityFields,
    } = this.props;

    if (showParticipantIdentityFields) {
      if (!isEmail(values.address) && !isPhone(values.address)) {
        errors({ address: 'Email or phone incorrect' });
        return;
      }
    }

    EventTracking.tap(eventScreenName, 'respond', UI_CONTEXT);

    const hasPaid = (
      this.props.editableEventRecipient &&
      this.props.editableEventRecipient.hasPaid()
    );

    // If RSVP yes and user has not paid already
    // then user has no choice but to pay. Otherwise
    // pass whatever the checkbox value is.
    const isContributing = (
      (!hasPaid && this.state.response === ATTENDANCE.YES) ||
      this.state.contribute
    );

    onValidSubmit({
      ...values,
      response: this.state.response,
      contribute: isContributing,
    });
  },

  onValid() {
    if (this.state.disabled) {
      this.setState({ disabled: false });
    }
  },

  onInvalid() {
    if (!this.state.disabled) {
      this.setState({ disabled: true });
    }
  },

  onContributeChange() {
    this.setState({ contribute: !this.state.contribute });
  },

  shouldDisplayContribute() {
    return (
      this.props.isCollectingMoney && (
        this.state.response === ATTENDANCE.MAYBE ||
        this.state.response === ATTENDANCE.NO || (
          this.props.editableEventRecipient &&
          this.props.editableEventRecipient.hasPaid()
        )
      )
    );
  },

  renderContributionCheckbox() {
    const label = (
      this.props.editableEventRecipient &&
      this.props.editableEventRecipient.hasPaid() ?
        'I would like to send money again for this activity' :
        'I would like to send money for this activity'
    );

    return (
      <FormCheckBox
        name="contribute"
        checked={this.state.contribute}
        onChange={this.onContributeChange}
        label={label}
        eventElementName="participant_contribute"
      />
    );
  },

  renderNoteField() {
    const {
      eventScreenName,
      editableEventRecipient,
    } = this.props;

    return (
      <FocusEventTrigger
        eventScreenName={eventScreenName}
        eventElementName="add_note">
        <FormInput
          data-test-selector="note_input"
          name="note"
          component={Textarea}
          value={editableEventRecipient && editableEventRecipient.getNote()}
          className={cx(styles.textareaInput)}
          placeholder="Add a private message for the teacher (e.g., student's name or t-shirt size)"
        />
      </FocusEventTrigger>
    );
  },

  shouldFormBeDisabled(): boolean {
    return !!(
      this.context.isPreview ||
      this.state.disabled || /* formzy form validation */
      this.state.response === ATTENDANCE.PENDING ||
      !this.state.response
    );
  },

  renderParticipantIdentityFields() {
    const { eventScreenName } = this.props;

    const verticalPositioning = this.props.width < 521;

    const name = (
      <FocusEventTrigger
        eventScreenName={eventScreenName}
        eventElementName="add_name">
        <FormInput
          data-test-selector="name_input"
          name="name"
          required="isRequired"
          className={cx(!verticalPositioning && styles.nameInput)}
          placeholder="Your name"
          validationErrors={{
            isRequired: 'A name is required.',
          }}
        />
      </FocusEventTrigger>
    );

    const address = (
      <FocusEventTrigger
        eventScreenName={eventScreenName}
        eventElementName="add_email_address">
        <FormInput
          data-test-selector="address_input"
          name="address"
          required="isRequired"
          className={cx(!verticalPositioning && styles.emailInput)}
          showErrorAfterBlur
          placeholder="Email or phone number"
          validationErrors={{
            isRequired: 'An email address or phone number is required.',
          }}
        />
      </FocusEventTrigger>
    );

    if (verticalPositioning) {
      return (
        <div>
          <div>
            {name}
          </div>
          <div>
            {address}
          </div>
        </div>
      );
    }

    return (
      <div className={cx(styles.row)}>
        {name}
        {address}
      </div>
    );
  },

  render() {
    const {
      className,
      processingSubmit,
      showParticipantIdentityFields,
    } = this.props;

    const hasRSVP = (
      this.props.editableEventRecipient &&
      this.props.editableEventRecipient.getAttendance() !== 'pending'
    );

    const submitText = hasRSVP ? 'Change response' : 'Respond';
    return (
      <div className={cx(styles.this, className)}>
        <EventRSVPForm
          buttonSize="medium"
          onChange={this.onResponseChange}
          initialResponse={this.state.response}
        />

        <Form
          className={cx(styles.form)}
          onValid={this.onValid}
          onInvalid={this.onInvalid}
          onValidSubmit={this.onValidSubmit}>
          {showParticipantIdentityFields && this.renderParticipantIdentityFields()}
          {this.renderNoteField()}
          {this.shouldDisplayContribute() && this.renderContributionCheckbox()}

          <Button
            size="small"
            data-test-selector="rsvp_submit_button"
            loading={processingSubmit}
            className={cx(styles.submitButton)}
            disabled={this.shouldFormBeDisabled()}>
            {submitText}
          </Button>

          <hr className={styles.divider} />

          <div className={styles.tos}>
            <span>
              {'By responding to this invitation, you agree to our '}
              <Link
                weight="semibold"
                href={LinkConstants.TERMS_OF_SERVICE}
                target="_blank">
                Terms of Service
              </Link>
              {' and '}
              <Link
                weight="semibold"
                href={LinkConstants.PRIVACY_POLICY}
                target="_blank">
                Privacy Policy
              </Link>.
              {' '}
              {'The activity organizer may contact you with updates ' +
               'about time, location, or other details.'}
            </span>
          </div>
        </Form>
      </div>
    );
  },
});

export default trackView(withWidth(EventParticipationForm));



// WEBPACK FOOTER //
// ./src/payments/components/EventParticipationForm.jsx